// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginBox_box__9I8na {
  padding: 20px 40px;
  width: 800px;
  border-radius: 10px;
  border: 1px solid var(--light-grey);
  background: white;
}
.LoginBox_box__9I8na .LoginBox_title__NHfwV {
  text-align: center;
  font-size: 26px;
}
.LoginBox_box__9I8na .LoginBox_login-form__4PYZK {
  width: 100%;
  margin: 40px 0 10px 0;
}
.LoginBox_box__9I8na .LoginBox_login-form__4PYZK .LoginBox_form-input__rVVPj {
  width: 100%;
  margin-top: 15px;
}
.LoginBox_box__9I8na .LoginBox_login-form__4PYZK .LoginBox_form-input__rVVPj .LoginBox_input-title__8pKgu {
  font-size: 14px;
  margin-bottom: 10px;
}
.LoginBox_box__9I8na .LoginBox_login-form__4PYZK .LoginBox_form-input__rVVPj .LoginBox_input__ugwLE input {
  height: 30px;
}
.LoginBox_box__9I8na .LoginBox_login-status__BWXEO {
  font-size: 14px;
  color: red;
  margin-bottom: 10px;
}
.LoginBox_box__9I8na .LoginBox_forgot-password__X7zk2 {
  font-size: 14px;
  color: var(--dark-grey);
  cursor: pointer;
  text-decoration: underline;
}
.LoginBox_box__9I8na .LoginBox_login-button__yAw9\\+ {
  width: 100%;
  margin: 20px 0 20px 0;
}
.LoginBox_box__9I8na .LoginBox_login-button__yAw9\\+ button {
  cursor: pointer;
  width: 100%;
  height: 40px;
  background: var(--explore-color);
  color: white;
  border: none;
  border-radius: 10px;
}
.LoginBox_box__9I8na .LoginBox_social-network-login__LgXxI {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.LoginBox_box__9I8na .LoginBox_social-network-login__LgXxI .LoginBox_social-network-box__74UdK {
  border-radius: 10px;
  border: 1px solid var(--light-grey);
  padding: 10px 40px;
  margin-right: 10px;
}
.LoginBox_box__9I8na .LoginBox_social-network-login__LgXxI .LoginBox_social-network-box__74UdK svg {
  width: 17px;
  height: 17px;
}
.LoginBox_box__9I8na .LoginBox_social-network-login__LgXxI .LoginBox_social-network-box__74UdK svg path {
  stroke-width: 0.5px;
}
.LoginBox_box__9I8na .LoginBox_social-network-login__LgXxI .LoginBox_social-network-box__74UdK .LoginBox_icon-negative__Zwo0S {
  display: flex;
  justify-content: center;
}
.LoginBox_box__9I8na .LoginBox_social-network-login__LgXxI .LoginBox_social-network-box__74UdK .LoginBox_icon-with-color__3-JFM {
  display: none;
  justify-content: center;
}
.LoginBox_box__9I8na .LoginBox_social-network-login__LgXxI .LoginBox_social-network-box__74UdK:hover {
  cursor: pointer;
  border: 1px solid var(--explore-color);
}
.LoginBox_box__9I8na .LoginBox_social-network-login__LgXxI .LoginBox_social-network-box__74UdK:hover .LoginBox_icon-negative__Zwo0S {
  display: none;
}
.LoginBox_box__9I8na .LoginBox_social-network-login__LgXxI .LoginBox_social-network-box__74UdK:hover .LoginBox_icon-with-color__3-JFM {
  display: flex;
}
.LoginBox_box__9I8na .LoginBox_register__4-XBZ {
  font-size: 14px;
}
.LoginBox_box__9I8na .LoginBox_register__4-XBZ span {
  color: #1677ff;
  text-decoration: underline;
}

.LoginBox_divider__\\+3RKF {
  margin: 8px 0 !important;
}

@media only screen and (min-width: 481px) and (max-width: 1025px) {
  .LoginBox_box__9I8na {
    padding: 20px 40px;
    width: 479px;
  }
}
@media only screen and (max-width: 480px) {
  .LoginBox_box__9I8na {
    padding: 20px 40px;
    width: 95%;
  }
}`, "",{"version":3,"sources":["webpack://./src/LandingPage/Components/LoginBox/LoginBox.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,iBAAA;AACF;AAAE;EACE,kBAAA;EACA,eAAA;AAEJ;AAAE;EACE,WAAA;EACA,qBAAA;AAEJ;AADI;EACE,WAAA;EACA,gBAAA;AAGN;AAFM;EACE,eAAA;EACA,mBAAA;AAIR;AADQ;EACE,YAAA;AAGV;AAEE;EACE,eAAA;EACA,UAAA;EACA,mBAAA;AAAJ;AAEE;EACE,eAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;AAAJ;AAEE;EACE,WAAA;EACA,qBAAA;AAAJ;AACI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AACN;AAEE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AACI;EACE,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,kBAAA;AACN;AAAM;EACE,WAAA;EACA,YAAA;AAER;AADQ;EACE,mBAAA;AAGV;AAAM;EACE,aAAA;EACA,uBAAA;AAER;AAAM;EACE,aAAA;EACA,uBAAA;AAER;AACI;EACE,eAAA;EACA,sCAAA;AACN;AAAM;EACE,aAAA;AAER;AAAM;EACE,aAAA;AAER;AAEE;EACE,eAAA;AAAJ;AACI;EACE,cAAA;EACA,0BAAA;AACN;;AAGA;EACE,wBAAA;AAAF;;AAGA;EACE;IACE,kBAAA;IACA,YAAA;EAAF;AACF;AAEA;EACE;IACE,kBAAA;IACA,UAAA;EAAF;AACF","sourcesContent":[".box {\n  padding: 20px 40px;\n  width: 800px;\n  border-radius: 10px;\n  border: 1px solid var(--light-grey);\n  background: white;\n  .title {\n    text-align: center;\n    font-size: 26px;\n  }\n  .login-form {\n    width: 100%;\n    margin: 40px 0 10px 0;\n    .form-input {\n      width: 100%;\n      margin-top: 15px;\n      .input-title {\n        font-size: 14px;\n        margin-bottom: 10px;\n      }\n      .input {\n        input {\n          height: 30px;\n        }\n      }\n    }\n  }\n  .login-status {\n    font-size: 14px;\n    color: red;\n    margin-bottom: 10px;\n  }\n  .forgot-password {\n    font-size: 14px;\n    color: var(--dark-grey);\n    cursor: pointer;\n    text-decoration: underline;\n  }\n  .login-button {\n    width: 100%;\n    margin: 20px 0 20px 0;\n    button {\n      cursor: pointer;\n      width: 100%;\n      height: 40px;\n      background: var(--explore-color);\n      color: white;\n      border: none;\n      border-radius: 10px;\n    }\n  }\n  .social-network-login {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n    .social-network-box {\n      border-radius: 10px;\n      border: 1px solid var(--light-grey);\n      padding: 10px 40px;\n      margin-right: 10px;\n      svg {\n        width: 17px;\n        height: 17px;\n        path {\n          stroke-width: 0.5px;\n        }\n      }\n      .icon-negative {\n        display: flex;\n        justify-content: center;\n      }\n      .icon-with-color {\n        display: none;\n        justify-content: center;\n      }\n    }\n    .social-network-box:hover {\n      cursor: pointer;\n      border: 1px solid var(--explore-color);\n      .icon-negative {\n        display: none;\n      }\n      .icon-with-color {\n        display: flex;\n      }\n    }\n  }\n  .register {\n    font-size: 14px;\n    span {\n      color: #1677ff;\n      text-decoration: underline;\n    }\n  }\n}\n.divider {\n  margin: 8px 0 !important;\n}\n\n@media only screen and (min-width: 481px) and (max-width: 1025px) {\n  .box {\n    padding: 20px 40px;\n    width: 479px;\n  }\n}\n@media only screen and (max-width: 480px) {\n  .box {\n    padding: 20px 40px;\n    width: 95%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `LoginBox_box__9I8na`,
	"title": `LoginBox_title__NHfwV`,
	"login-form": `LoginBox_login-form__4PYZK`,
	"form-input": `LoginBox_form-input__rVVPj`,
	"input-title": `LoginBox_input-title__8pKgu`,
	"input": `LoginBox_input__ugwLE`,
	"login-status": `LoginBox_login-status__BWXEO`,
	"forgot-password": `LoginBox_forgot-password__X7zk2`,
	"login-button": `LoginBox_login-button__yAw9+`,
	"social-network-login": `LoginBox_social-network-login__LgXxI`,
	"social-network-box": `LoginBox_social-network-box__74UdK`,
	"icon-negative": `LoginBox_icon-negative__Zwo0S`,
	"icon-with-color": `LoginBox_icon-with-color__3-JFM`,
	"register": `LoginBox_register__4-XBZ`,
	"divider": `LoginBox_divider__+3RKF`
};
export default ___CSS_LOADER_EXPORT___;
